import { IoIosArrowForward } from "react-icons/io";
import { Link } from "react-router-dom";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import AdminAccountTable from "../../components/react-tables/adminAccountTable/AdminAccountTable";

function AdminAccountPage() {
  return (
    <div id="adminAccount">
      <div className="top-bar">
        <h2>Administrateurs</h2>
        <div className="pagination">
          <Link to="#" className="link">
            Accueil
          </Link>
          <IoIosArrowForward color="#A7A7A7" />
          <Link to="#" className="link">
            Gestion
          </Link>
          <IoIosArrowForward color="#A7A7A7" />
          <Link to="#" className="link">
            Administrateur
          </Link>
        </div>
      </div>

      <AdminAccountTable />
    </div>
  );
}

export default AdminAccountPage;
